export const handleBackClick = (history, defaultPath) => () => {
  // Check that there is actually somewhere to go back to
  if (history.length > 1) {
    history.goBack();
  } else {
    history.push(defaultPath);
  }
};
